import React from 'react';
import {observer} from "mobx-react-lite";
import {PLACES_ROUTE} from "../../../utils/consts";
import {useHistory} from "react-router-dom";
import { reachGoal } from "../../../utils/metrika/metrika";
import styles from './PlaceNavItem.module.css';

const PlaceNavItem = observer(({place}) => {
    const history = useHistory()

    return (
        <li className={styles.navItem}>
            <a
                className={styles.navLink}
                onClick={() => {
                    history.push(PLACES_ROUTE + '/' + place.id)
                    reachGoal("history.push(PLACES_ROUTE)")
                }}
            >
                {place.title}
            </a>
        </li>
    );
});

export default PlaceNavItem;